/**
 *  +----------------------------------------------------------------------
 *  | Copyright notion All rights reserved.
 *  +----------------------------------------------------------------------
 *  | 未经许可不能去掉notion相关版权
 *  +----------------------------------------------------------------------
 *  | Author: 诺行
 *  +----------------------------------------------------------------------
 */
import request from '../request.js'

// 获取号卡资源库列表
export function listSimCard(params) {
    return request({
        url: 'simCardResource/list.do?',
        method: 'post',
        data: params
    })
}

// 导出号卡资源库
export function exportSimCardSync(params) {
    return request({
        url: 'simCardResource/export.do?',
        method: 'post',
        data: params
    })
}

// 根据ID删除号卡资源
export function deleteById(params) {
    return request({
        url: 'simCardResource/delete.do?',
        method: 'post',
        data: params
    })
}

// 批量导入号卡资源
export function importExcel(params) {
    return request({
        url: 'simCardResource/batchImportSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量删除号卡资源
export function batchDelete(params) {
    return request({
        url: 'simCardResource/batchDelete.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 编辑号卡资源
export function editCard(params) {
    return request({
        url: 'simCardResource/update.do',
        method: 'post',
        data: params
    })
}

// 批量修改省份
export function batchUpdateProvince(params) {
    return request({
        url: 'simCardResource/batchUpdateProvince.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量修改认证
export function batchUpdateIsAuth(params) {
    return request({
        url: 'simCardResource/simCard/isAuth/batchUpdate.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量修改卡级秘钥
export function batchUpdateIsCardKey(params) {
    return request({
        url: 'simCardResource/simCard/isCardKey/batchUpdate.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量分销代理商
export function batchAssignAgent(params) {
    return request({
        url: 'simCardResource/simCard/agent/batchAssignSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量分销号卡
export function batchRecycleSync(params) {
    return request({
        url: 'simCardResource/simCard/agent/batchRecycleSync.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量修改优先级
export function batchUpdatePriority(params) {
    return request({
        url: 'simCardResource/simCard/priority/batchUpdate.do?',
        method: 'post',
        data: params,
        timeout: 20000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
}

// 批量更新写号状态（multipart：cardInfos / fileurl）
export function batchUpdateWriteStatus(params) {
    return request({
        url: 'simCardResource/batchUpdateWriteStatus.do?',
        method: 'post',
        data: params,
        timeout: 60000,
        headers: { 'Content-Type': 'multipart/form-data' }
    })
} 